/* eslint-disable @typescript-eslint/no-explicit-any */
import { axiosInstance } from '@/service/axios';

export interface SegundaViaResponse {
  link_segunda_via: string | null;
  base64_segunda_via: string | null;
  observacao: string | null;
}

export async function getBoleto(codigo_fatura: string): Promise<SegundaViaResponse> {
  const { data } = await axiosInstance.get('/faturas/segunda-via/', {
    params: { codigo_fatura },
  });
  return {
    link_segunda_via: data.link_segunda_via,
    base64_segunda_via: data.base64_segunda_via,
    observacao: data.observacao,
  };
}

export interface PixFaturaResponse {
  result?: boolean;
  error?: string | null;
  pix_copia_cola: string | null;
  pix_qrcode_base64: string | null;
  pix_qrcode_url: string | null;
  valor: string | number | null;
  pagador: string | null;
  descricao: string | null;
  expiracao_pix: string | null;
  gateway: string | null;
  observacao: string | null;
}

export async function getPixFatura(codigo_fatura: string | number): Promise<PixFaturaResponse> {
  const { data } = await axiosInstance.get('/faturas/pix/', {
    params: { codigo_fatura },
  });
  return {
    result: data.result,
    error: data.error,
    pix_copia_cola: data.pix_copia_cola ?? null,
    pix_qrcode_base64: data.pix_qrcode_base64 ?? null,
    pix_qrcode_url: data.pix_qrcode_url ?? null,
    valor: data.valor ?? null,
    pagador: data.pagador,
    descricao: data.descricao,
    expiracao_pix: data.expiracao_pix,
    gateway: data.gateway,
    observacao: data.observacao,
  };
}

export interface CircuitIdOption {
  value: string;
  label: string;
}

export async function fetchCircuitIds(): Promise<CircuitIdOption[]> {
  const { data } = await axiosInstance.get('/listar-circuit-ids/');
  if (data?.results?.result && data?.results?.['Ids de Circuitos']) {
    const circuitIdsArray = data.results['Ids de Circuitos'];
    return circuitIdsArray.map((item: number) => ({
      value: String(item),
      label: String(item),
    }));
  }
  return [];
}

export async function trocarCredenciaisRoteador(params: {
  circuit_id_integration: string;
  wifi_ssid: string;
  wifi_password: string;
}): Promise<void> {
  await axiosInstance.post('/trocar-credenciais-roteador/', null, {
    params: {
      wifi_ssid: params.wifi_ssid,
      wifi_password: params.wifi_password,
      circuit_id_integration: params.circuit_id_integration,
    },
  });
}
